import VerificarEmailLayer from "../components/VerificarEmailLayer";

const VerificarEmailPage = () => {
  return <VerificarEmailLayer />;
};

export default VerificarEmailPage;
